import { useState } from 'react';

import { listActivities } from 'services/indexer';

const pageSize = 7;

const useLoadMore = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasNextPage, setIsHasNextPage] = useState(true);
  const [data, setData] = useState([]);

  const loadMore = async (accountId, page = 1, type, date) => {
    setIsLoading(true);
    try {
      const { result } = await listActivities({
        accountId,
        page,
        type,
        date
      });

      const totalHits = result?.hits?.total?.value;

      if (totalHits > 0) {
        const totalPages = Math.ceil(totalHits / pageSize);

        if (page < totalPages + 1) {
          setData((prevData) => [
            ...prevData,
            ...result?.hits?.hits.map((hit) => {
              return {
                ...hit._source,
                activity_data: hit._source.activity_data
              };
            })
          ]);
        } else {
          setIsHasNextPage(false);
        }
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(`Failed to fetch activity: ${e}`);
    }
  };

  return { data, setData, loadMore, isLoading, hasNextPage };
};

export default useLoadMore;
